import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { isBrowser } from "react-device-detect";
import { Container, Card } from 'react-bootstrap';

class ExamPaperPdfHome extends Component {
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            Cookies.set("toggle", "wrapper");
        }
        this.forceUpdate();
    };

    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div
                        id="sidebar"
                        className={
                            isBrowser === true
                                ? "sidebar-menu d-none d-xl-block d-lg-block"
                                : "sidebar-menu d-block d-xl-none d-lg-none"
                        }
                    >
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        <Container fluid className="mt-4">
                            <Card className="shadow-sm mb-4 mt-4" style={{ borderRadius: '16px' }}>
                                <Card.Body className="p-4">
                                    {this.props.children}
                                </Card.Body>
                            </Card>
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(withApollo(ExamPaperPdfHome));
